import { render, staticRenderFns } from "./AddThumbnailsModal.vue?vue&type=template&id=0b23afba&scoped=true&"
import script from "./AddThumbnailsModal.vue?vue&type=script&lang=js&"
export * from "./AddThumbnailsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddThumbnailsModal.vue?vue&type=style&index=0&id=0b23afba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23afba",
  null
  
)

export default component.exports